






import Vue from 'vue'

interface CComputed {
  footer: string
}

export default Vue.extend<{}, {}, CComputed, {}>({
  name: 'Footer',
  computed: {
    footer() {
      return this.$store.getters.footer
    }
  }
})
